import { createContext } from "react";

type UserPointsContextType = {
  points: number | null;
  getPoints: () => Promise<void>;
};

const initial: UserPointsContextType = {
  points: null,
  getPoints: async () => {}
};

const UserPointsContext = createContext(initial);

export default UserPointsContext;
